module.exports = __webpack_public_path__ + "@/assets/img/angle-right.5ffca354.svg";